var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time-add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings---Workflows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workflow---Completed",
    transform: "translate(-564.000000, -342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delay",
    transform: "translate(528.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.000000, 18.000000)",
    id: "time-add"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.166667, 4.166667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 11.6666667,
    height: 11.6666667
  })), /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    transform: "translate(1.000000, 1.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 C2.24333333,0 0,2.24333333 0,5 C0,7.75666667 2.24333333,10 5,10 C7.75666667,10 10,7.75666667 10,5 C10,2.24333333 7.75722222,0 5,0 Z M6.35888889,6.57333333 L4.44444444,5.29722222 L4.44444444,2.22222222 L5.55555556,2.22222222 L5.55555556,4.70277778 L6.975,5.64888889 L6.35888889,6.57333333 Z",
    id: "Shape"
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.171a4a851a0f30989fd8f1ec642ef64c.svg";
export { ForwardRef as ReactComponent };